<!--下拉 DLQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{
                `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
              }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>下拉</p>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请选择一个选项"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="state.isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" mode="widthFix" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            mode="widthFix"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
      <div class="options">
        <div v-for="(option, index) in list" :key="index">
          <div class="option-item">
            <div class="option-item-top">
              <div class="option-item-top-left">
                <img
                  v-if="list.length > 2"
                  @click="delItem(index)"
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
                />
                <img
                  v-else
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-gray.svg"
                />
              </div>
              <div
                class="option-item-top-right"
                :style="{
                  border:
                    inputFocusIndex === `a${index}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <div class="option-item-top-right-up">
                  <input
                    placeholder-class="input-placeholder"
                    type="text"
                    :placeholder="'选项' + (index + 1)"
                    v-model="option.text"
                    @input="handleInput"
                    @focus="inputFocusIndex = 'a' + index"
                    @blur="inputFocusIndex = ''"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="add-view">
        <div class="add-batch" style="color: #ffffff">
          <el-checkbox
            label="必选题"
            v-model="isMust"
            :true-label="1"
            :false-label="0"
            class="custom-checkbox"
            @change="handleCheckboxChange"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            mode=""
            style="width: 13px; height: 13px"
          />
          <p>添加选项 {{ list.length + "/50" }}</p>
        </div>
        <div @click="batchAddOptions" class="add-batch">批量添加</div>
      </div>
    </div>
    <div v-if="type === 1" class="option-settings">
      <p></p>
      <el-checkbox
        label="选项随机排列"
        v-model="ifRandomize"
        style="transform: scale(1)"
      ></el-checkbox>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <PopupInput
      :showDialog="showpopup"
      @close="showpopup = false"
      @confirm="bitchConfirm"
      :aContent="''"
      :type="1"
    ></PopupInput>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  components: {
    PopupInput,
  },
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      showpopup: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    addOption() {
      if (this.list.length < 50) {
        this.list.push({
          id: "", //后台处理逻辑 创建时不传 唯一标识用
          text: "",
          isChoose: false,
          img_path: [],
          is_fill: 0, //是否填空 0否 1是
          fill_prompt: "",
          newDate: true,
        });
        this.handleUpdateQuestion();
      } else {
        this.$message.error("最多只能添加50个选项");
      }
    },

    batchAddOptions() {
      // 批量添加选项的逻辑
      this.showpopup = true;
    },
    bitchConfirm(e) {
      // 批量添加选项的逻辑
      this.showpopup = false;
      const count = e.split("\n").filter((item) => item.trim() !== "").length;
      if (count > 50 - this.list.length) {
        this.$message.error("最多只能添加50个选项");
        return;
      }
      const list = e
        .split("\n")
        .filter((item) => item.trim() !== "")
        .map((item) => {
          return {
            id: "", //后台处理逻辑 创建时不传 唯一标识用
            text: item,
            isChoose: false,
            img_path: [],
            is_fill: 0, //是否填空 0否 1是
            fill_prompt: "",
            newDate: true,
          };
        });
      this.list = this.list.concat(list);
      this.handleUpdateQuestion();
    },
    delItem(index) {
      if (this.updateType === 1) {
        if (this.list[index].newDate) {
          this.list.splice(index, 1);
        } else {
          this.$message.error("限制性修改状态下，不能删除之前的数据!");
        }
      } else {
        this.list.splice(index, 1);
      }
      this.handleUpdateQuestion();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          return item;
        }),
      });
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    cancelClick() {
      // this.dataObj.isMust = this.isMust ? 1 : 0;
      // this.dataObj.caseProblemImg = JSON.stringify(this.images);
      // this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      // this.dataObj.caseProblem = this.caseProblem;
      // this.dataObj.chooseList = JSON.stringify({
      //   list: this.list.map((item, index) => {
      //     item.is_fill = item.is_fill ? 1 : 0;
      //     return item;
      //   }),
      // });
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        this.$message.error("请输入题目");
      }
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "请选择一个选项" : this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          item.text = item.text === "" ? `选项${index + 1}` : item.text;
          return item;
        }),
      });
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleClick() {},
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        console.log("dataObj 变化了", newVal, oldVal);
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.list = JSON.parse(newVal.chooseList).list.map((item) => {
          item.is_fill = item.is_fill === 1;
          return item;
        });
        this.ifRandomize = newVal.ifRandomize === 1;
        this.isMust = newVal.isMust === 1;
        this.images = JSON.parse(newVal.caseProblemImg);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}
.textarea-box textarea {
  color: #4c4a56;
}

::v-deep(.u-checkbox__label-wrap) {
  white-space: nowrap;
  writing-mode: horizontal-tb;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditDLQ.vue